import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        caseTypeList: [],
        
    },
    getter: {

    },
    setter: {
    
    },
    mutations: {
        setCaseTypeList(state,list){
            state.caseTypeList = list;
        }
    },
    actions: {

    }
})


// WEBPACK FOOTER //
// ./src/modules/store/index.js